// i18n app gest — naissance GS Gestion (MASTER-INTEGRATION-GESTION-FRAG0 2026-07-14).
// Initialise i18next via @gs/i18n (namespace 'gest' + 'common' partage au runtime).
// Importe par main.tsx AVANT le render React.
import { initI18n } from '@gs/i18n';
// Namespace `feedback` fourni par le package transverse (BLITZ-FBK-FOUNDATION).
import { feedbackResources } from '@gs/feedback/client';

import gestFr from './locales/gest.fr.json';
import gestEn from './locales/gest.en.json';

const i18n = initI18n({
  appNamespace: 'gest',
  resources: {
    fr: { gest: gestFr, ...feedbackResources.fr },
    en: { gest: gestEn, ...feedbackResources.en },
  },
});

export default i18n;
export { useTranslation, Trans, setLocale, SUPPORTED_LOCALES } from '@gs/i18n';
export type { SupportedLocale } from '@gs/i18n';
